export default {
  LOCAL: 'LOCAL',
  INT: 'INT',
  XQA: 'XQA',
  USE: 'USE',
  PROD: 'PROD', // TODO: this is assumed, change once prod is up
};
